import * as React from 'react';
import { resolve } from 'inversify-react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import QuoteItineraryGroupFormView from './quote-group-form.view';
import { TourItineraryDateDataService } from 'src/app/products/tour-itineraries/tour-itinerary-date/tour-itinerary-date.data';
import { TourItineraryDataService } from 'src/app/products/tour-itineraries/form/tour-itinerary.data';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { QuoteItineraryGroupListDataService } from '../list/quote-group-list.data';
import { FormatService } from 'src/core/services/format.service';

interface Props extends ControllerProps<{ id: string }> {
	defaultLanguage?: string;
}

interface State {
	mode: ControlMode;
	defaultLanguage: string;
}

interface QuoteRelation {
	id: number | string;
	quoteId?: number;
}

@observer
export class QuoteItineraryGroupFormController extends React.Component<Props, State> {
	@resolve
	private contextService: ContextService;

	@resolve
	configurationService: ConfigurationService;

	@resolve
	private toast: ToastNotifications;

	@resolve
	private formatService: FormatService;

	private dataService: DataSet<QuoteItineraryGroupSummary>;

	private tourItineraryDateService: DataSet<TourItineraryDateItem>;

	private tourItineraryService: DataSet<TourItineraryItem>;

	constructor(props: any) {
		super(props)

		this.state = {
			mode: 'display',
			defaultLanguage: 'en'
		}
	}

	@computed
	private get title() {
		if (this.dataService && this.dataService.item) {
			const quote = this.dataService.item;
			return `
				${quote.quoteNumber},
				Itinerary ${quote.tourItineraryName} (${quote.tourItineraryService}),
				From ${quote.dateFromText},
				To ${quote.dateToText})
			`;
		}

		return '';
	}

	public componentDidMount() {
		this.initialize(this.props.match.params.id);
	}

	public componentWillReceiveProps(nextProps: Readonly<Props>) {
		if (nextProps.match.params.id !== this.props.match.params.id) {
			this.initialize(nextProps.match.params.id);
		}
	}

	@autobind
	async save(): Promise<void> {
		
	}

	public render(): React.ReactNode {
		if (this.dataService == null || this.dataService.item == null) {
			return null;
		}
		if (this.tourItineraryService == null || this.tourItineraryService.item == null) {
			return null;
		}
		
		return (
			<QuoteItineraryGroupFormView
				title={this.title}
				model={this.dataService.item}
				mode={this.state.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				contextService={this.contextService}
				setBusy={this.props.setBusy}
				defaultLanguage={this.state.defaultLanguage}
				itinerary={this.tourItineraryService.item}
			/>
		);
	}

	private onModeChanged = (mode: ControlMode) => {
		this.setState({ mode: mode });
	}


	private async loadConfiguration(): Promise<void> {
		const appConfig = await this.configurationService.current();
		
		this.setState({
			defaultLanguage: appConfig.defaultLanguage
		});
	}

	private initialize = async (id: string): Promise<void> => {
		this.props.setBusy(true);
		await this.loadConfiguration();
		try {
			await this.loadQuote(id);
		} catch (error) {
			this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
		} finally {
			this.props.setBusy(false);
		}
	}

	private async loadQuote(id: string): Promise<void> {

		this.tourItineraryDateService = TourItineraryDateDataService.make(this.contextService);
		this.tourItineraryService = TourItineraryDataService.make(this.contextService);
		this.dataService = QuoteItineraryGroupListDataService.make(this.contextService, this.formatService);

		this.dataService.addFilter("id", 'eq', id);
		this.dataService.addSorting('id', 'asc');

		var [data] = await this.dataService.load(query => query);

		console.log(data, id);

		await this.loadItineraries(data.tourItineraryDateId);
	}

	private loadItineraries = async (id: any) => {

		this.tourItineraryDateService.addFilter('id', 'eq', id);
		this.tourItineraryDateService.addSorting('id', 'asc');

		var [itineraryDate] = await this.tourItineraryDateService.load(query => query);	

		const itineraryId = itineraryDate.tourItineraryId;

		this.tourItineraryService.addFilter("id", 'eq', itineraryId);
		this.tourItineraryService.addSorting('id', 'asc', true);
		await this.tourItineraryService.load(query => query);
	}

	private cancel = async (): Promise<boolean> => {
		
		this.props.history.push('/bookings/groups');
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/quote-group-form.controller.tsx